import { render, staticRenderFns } from "./UserProfileImage..vue?vue&type=template&id=310a740c&"
import script from "./UserProfileImage..vue?vue&type=script&lang=js&"
export * from "./UserProfileImage..vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports